<template>
  <v-container class="max-width-1200">

    <v-row class="justify-center">

      <v-col cols="12" md="7">
        <v-row>
          <v-col class="pb-0 headline text-uppercase">
            {{ $t('hardwer.catalog.title') }}
          </v-col>
        </v-row>
        <v-row>
          <v-col  class="display-1">
            {{ $t('hardwer.catalog.subtitle')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-justify">
            {{ $t('hardwer.catalog.text.01')}} {{ $t('hardwer.catalog.text.02')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-justify">
            <v-btn
              color="primary" block depressed tile dark
              @click="downloadItem()"
              target="blank">
              <span style="color: #ffffff;">{{$t("hardwer.catalog.download")}}</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-justify">
            {{ $t('hardwer.catalog.text.03')}}
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="5" class="align-center d-flex">
        <v-img
          src="@/assets/img/hw-catalog-01.jpeg"
          cover
          class="ml-auto"
          style="width:100%">
        </v-img>
      </v-col>

    </v-row>

    <v-row>
      <v-col>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'SoftwareDevelopment',
    extends: DataComponentBase,

    data: () => ({
    }),

    methods: {
      downloadItem () {
        let url = './RubinHardwareCatalog2022.pdf'
        let label = "RubinHardwareCatalog2022"
        window.open(url)
      }
    },
  }
</script>
